import { Module, VuexModule, MutationAction } from "vuex-module-decorators";
import { ServicesFactoryInstance } from "../../components/Controls/ServicesFactory";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";

@Module({ namespaced: true })

class ParametersStore extends VuexModule {
	public storeVariableListeFonctions: ParametreDto[] = [];

	@MutationAction({ mutate: ["storeVariableListeFonctions"] })
	public async fetchFonctions(): Promise<{ storeVariableListeFonctions: ParametreDto[] }> {
		const data = await ServicesFactoryInstance.ParametresService.getFonctions();

		return { storeVariableListeFonctions: data };
	}
}

export default ParametersStore;



// WEBPACK FOOTER //
// ./src/store/modules/ParametersStore.ts